import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import TextField from "../parts/TextField";
import { api } from '../../../api';
import Alert from "../parts/Alert";
import RichTextEditor from "../parts/RichTextEditor/Index";
import Button from "../parts/Button";
import { SessionContext } from "../layouts/UserLayout";
import FilesField from "../parts/FilesField";
import { useNavigate } from "react-router-dom";
import CheckboxField from "../parts/Checkbox";
import AutoSuggestShopNameField from "../parts/AutoSuggestShopNameField";

const CafeNoteFormStyle = styled.div`
  background: none;
  text-align: center;
  max-width: 700px;
  margin: 0 auto 10px;
`;

const ImageUploadStyle = styled.div`
  display: flex;
  gap: 15px;
  text-align: left;
  flex-wrap: wrap;
  margin-bottom: 10px;
  width: 100%;
`;

const ImageStyle = styled.div`
  position: relative;
  display: inline-block;
  width: calc(100% /3 - 15px);

  button {
    position: absolute;
    background: #393432;
    border: none;
    border-radius: 25px;
    color: white;
    cursor: pointer;
    font-size: 12px;
    width: 25px;
    height: 25px;
    top: -10px;
    right: -10px;
    padding: 0;
  }

  img {
    object-fit: cover;
    width: 100%;
    height: 130px;
  }

  @media (max-width: 767px) {
    width: calc(100% /2 - 15px);
  }
`;

const ButtonStyle = styled(Button)`
  max-width: 250px;
  width: 100%;
`;

const CreateCafeNoteForm: React.FC = () => {
  const searchParams = new URLSearchParams(location.search);
  const today = new Date();
  today.setDate(today.getDate());
  const yyyy = today.getFullYear();
  const mm = ("0"+(today.getMonth()+1)).slice(-2);
  const dd = ("0"+today.getDate()).slice(-2);
  const navigate = useNavigate();
  const [title, setTitle] = useState<string>();
  const [visitingDate, setVisitingDate] = useState<string>(`${yyyy}-${mm}-${dd}`);
  const [body, setBody] = useState<string>();
  const [images, setImages] = useState<Array<{ id: number, url: string }>>([]);
  const [isPublic, setIsPublic] = useState<boolean>(false);
  const [message, setMessage] = useState(null);
  const [messageLevel, setMessageLevel] = useState(null);
  const [shopId, setShopId] = useState<number>(Number(searchParams.get('shop_id')));
  const [submitting, setSubmitting] = useState<boolean>(false);
  const shopName = searchParams.get('shop_name');
  const session = useContext(SessionContext);
  const userId = session.userId;

  const onClickSaveButton = async () => {
    setSubmitting(true);
    const params = {
      cafeNote: {
        title,
        visitingDate,
        body,
        shopId,
        userId,
        isPublic,
        images
      }
    };
    await api.postCafeNote(params).then((response) => {
      navigate(`/user/cafe-notes/${response.data.id}`, {
        state: {
          message: response.data.message,
          level: 'success'
        }
      });
    }).catch(error => {
      setMessage(error.response.data.message);
      setMessageLevel('error');
    });

    setSubmitting(false);
  };

  const onClickDeleteImageButton = (index) => {
    const uploadedFiles = [...images];
    uploadedFiles.splice(index, 1);
    setImages(uploadedFiles);
  };

  return (
    <CafeNoteFormStyle>
      <AutoSuggestShopNameField id='shop-name' placeholder='店舗名' label='店舗名' mb='20px' selectShopId={shopId} setSelectShopIdAction={setShopId} value={shopName} disabled={!!shopName} />
      { (images.length !== 0) && <ImageUploadStyle>
        { images.map((image, index) => {
          return (
            <ImageStyle key={index}>
              <button onClick={() => onClickDeleteImageButton(index)}>×</button>
              <img src={image.url} alt="店舗画像"/>
            </ImageStyle>
          );
        }) }
      </ImageUploadStyle> }
      <FilesField id='shop-image' placeholder='画像※10枚まで' mb='20px' files={images} setFiles={setImages} required={true} disabled={images.length >= 10} />
      <TextField type='text' label='タイトル' placeholder='タイトル' mb='20px' value={title} onChange={event => setTitle(event.target.value)} />
      <TextField type='date' label='訪問日' placeholder='訪問日' mb='20px' required={true} value={visitingDate} onChange={event => setVisitingDate(event.target.value)} />
      <RichTextEditor setHtml={setBody} />
      <CheckboxField id='is-public' label='ノートを一般公開する' mb='20px' onChange={event => setIsPublic(event.target.checked)} />
      <ButtonStyle onClick={onClickSaveButton} submitting={submitting} submittingMessage='送信中...'>送信</ButtonStyle>
      {message && <Alert level={messageLevel}>{ message }</Alert>}
    </CafeNoteFormStyle>
  );
};

export default CreateCafeNoteForm;
